import { render, staticRenderFns } from "./AdminStudyItemForm.vue?vue&type=template&id=e12c5a86&"
import script from "./AdminStudyItemForm.vue?vue&type=script&lang=js&"
export * from "./AdminStudyItemForm.vue?vue&type=script&lang=js&"
import style0 from "./AdminStudyItemForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports